class BlogAssets {
  constructor() {

    this.cta = document.querySelectorAll('a.blog-button');

  }

  init() {
    console.log('blogs');
    console.log(this.cta);

    this.cta.forEach((cta) => {
      let _parent = cta.parentNode;
          _parent.style.textAlign = 'center';
      console.log(_parent);

    });

  }

}

class TagFilter extends HTMLSelectElement {
  constructor() {
    super();

    this.beforeInit();
    this.addEventListener('change', this.onChange);
  }

  beforeInit() {
    const value = this.options[this.selectedIndex].text;
    const width = theme.getElementWidth(this, value);
    this.style.setProperty('--width', `${width}px`);
  }

  onChange() {
    window.location.href = this.value;
  }
}

customElements.define('tag-filter', TagFilter, { extends: 'select' });

let blogAssets = new BlogAssets();
blogAssets.init();